import React, { useState, useEffect } from 'react'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import L from "leaflet";
import './mappy.css'
import axios from 'axios'
import jwt_decode from 'jwt-decode';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/dist/styles.css';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { Redirect } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';


const Mappy = () => {

  useEffect(() => {
    getEvents()
    getInterets()
    getId()
   

  }, [])

  let history = useHistory()


  const [event, setEvent] = useState([])
  const [user, setUser] = useState([])

  const [interet, setInteret] = useState([])
  const [idUserEvent, setIdUserEvent] = useState({})
  const [modal, setModal] = useState(false);
  const [transform, setTransform] = useState({
    rdv_point: null,
    date: null
  })

const [modalToggler, setModalToggler] = useState({})
const [interestModalToggler, setInterestModalToggler] = useState({})

  const toggler = (index) => {
    setModalToggler({...modalToggler,[index]:!modalToggler[index]})
  }
  const interestToggler = (index) => {
    setInterestModalToggler({...interestModalToggler,[index]:!interestModalToggler[index]})
  }

  const popupValidate = () => {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: `Ta participation à cet évènement a bien été prise en compte !`,
      showConfirmButton: false,
      timer: 3000
    })
  }


  const popupEnregistrer = () => {
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: `Il ne te reste plus qu'a soumettre !`,
    })
  }



  const getId = () => {
    if (localStorage.userToken) {
      const token = localStorage.userToken
      const decoded = jwt_decode(token)
      setIdUserEvent({ ...idUserEvent, UserId: decoded.id })

    }
    else {
      return (
        <Redirect to="/mappy"></Redirect>
      )
    }
  }

  const getEvents = () => {
    axios.get(`https://clean-my-calanques.herokuapp.com/events/evenements`)
      .then(response => {
        setEvent(response.data)
        const length = response.data.length
        let modalsNeeded = {}
        for(let i=0; i<length; i++){
          modalsNeeded[i]=false
        }
        setModalToggler(modalsNeeded)
      })  
      .catch(err => console.error(err))
  }


  const getInterets = () => {
    axios.get(`https://clean-my-calanques.herokuapp.com/events/interets`)
      .then(response =>{ setInteret(response.data)
        const length = response.data.length
        let modalsNeeded = {}
        for(let i=0; i<length; i++){
          modalsNeeded[i]=false
        }
        setInterestModalToggler(modalsNeeded)
      })
      .catch(err => console.error(err))
  }



  const selectEvent = (e) => {
    const sentEvent = {UserId : localStorage.userId, EventId: e.id, role : "Participant" }
    axios.post("https://clean-my-calanques.herokuapp.com/reward", sentEvent)
      .then(popupValidate())
      .catch(err => console.log(err))
      console.log(sentEvent)
  }

  const selectInteret = (e, index) => {
    const sent = { UserId: localStorage.userId, EventId: e.id, role : "Organisateur",  rdv_point: transform.rdv_point, date: transform.date }
    {
      transform.rdv_point !== null & transform.date !== null ?
        axios.put('https://clean-my-calanques.herokuapp.com/organize', sent)
          .then(x => console.log(sent))
          .then(x => () => interestToggler(index))
          .then(Swal.fire({
            text: `L'évènement a bien été soumis !`,
            icon: 'success',
          }))
          .then(history.push("/mappy"))
          .catch(err => console.log(err))
        : Swal.fire({
          text: 'Ajoute un point de rendez-vous et une date !',
          icon: 'warning',
        })
    }



    console.log(sent)
  }

  const myIcon = new L.Icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  const myIcon2 = new L.Icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });



  return (

    <>
      <div >
        <h1 className='titleHome' >Suis nos aventures...</h1>
      </div>
      <div className='map' >


        <Map className="markercluster-map" center={[43.205, 5.49]} zoom={10} maxZoom={18}>
          <TileLayer
            url='https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
          />


          <MarkerClusterGroup
            showCoverageOnHover={false}
            spiderfyDistanceMultiplier={2}

          >
            {event.map((e,index) => {

              let pos = e.position.split(",")
              pos[0] = Number(pos[0])
              pos[1] = Number(pos[1])


              return (

                <Marker closePopupOnClick={false} key={e.id}
                  position={{ lat: pos[0], lng: pos[1] }}
                  icon={myIcon}
                >
                  <Popup autoClose={false} className="popupevent">
                    <h5>Participer à un évènement</h5>
                    <li >{e.name}</li>
                    <li>{e.mission}</li>
                    <li><img src={e.url} style={{ width: "100%", listStyleType: "none", borderRadius: "5px" }} alt="imagePopup" ></img></li>
                  
                    { localStorage.userId ? (
                      <>
                    <div className="buttonParticipe">
                      <li><Button onClick={() => selectEvent(e)} color="danger" size="sm ">Je participe !</Button></li>
                      <li><Button onClick={() => toggler(index)} color="info" size="sm "> Plus d'info </Button></li>
                    </div>
                    <Modal isOpen={modalToggler[index]} toggle={() => toggler(index)}>
                        <ModalHeader toggle={() => toggler(index)}>Tu veux plus d'info ?</ModalHeader>
                        <ModalBody>


                          <>
                          <h1>{e.name}</h1>
                          <img src={e.url} style={{ width: "100%", listStyleType: "none", borderRadius: "5px" }} alt="imagePopup" ></img>
                    <p>{e.date}</p>
                    <p>{e.rdv_point}</p>
                    <p>{e.mission}</p>
                  
                          </>
              
                        </ModalBody>
                      </Modal>
                    </>
                    ) : (
                      null
                    )
                    }
                  </Popup>
                </Marker>
              )

            })
            }


            {interet.map((e, index) => {

              const location = e.position.split(",")
              location[0] = Number(location[0])
              location[1] = Number(location[1])

              return (

                <Marker closePopupOnClick={false} key={e.id}
                  position={{ lat: location[0], lng: location[1] }}
                  icon={myIcon2}
                >
                  <Popup autoClose={false} className="popupinteret">
                    <h5>Organiser un évènement</h5>
                    <li key={e.id}>{e.mission}</li>
                    <li><img src={e.url} style={{ width: "100%", listStyleType: "none", borderRadius: "5px" }} alt="imageEvent" ></img></li>
                    {localStorage.userId ? (
<>
                    <div className="buttonParticipe">
                      <li><Button onClick={() => interestToggler(index)} color="info" size="sm" style={{ marginTop: "5px" }}> Compléter </Button>{' '}</li>
                    </div>
                    

                    <form >
                      <Modal isOpen={interestModalToggler[index]} toggle={() => interestToggler(index)}>
                        <ModalHeader toggle={() => interestToggler(index)}>N'oublie pas !</ModalHeader>
                        <ModalBody>
                          <input placeholder="Point de Rendez-vous" name='firstname' value={transform.rdv_point} type='text' onChange={(e) => setTransform({ ...transform, rdv_point: e.target.value })} />
                          <input placeholder="Date" name='date' value={transform.date} type='date' onChange={(e) => setTransform({ ...transform, date: e.target.value })} />
                          <Button onClick={() => popupEnregistrer()} className="image-btn" type='submit'> Enregistrer</Button>
                          <li><Button onClick={() => selectInteret(e, index )} color="info" size="sm" style={{ marginTop: "5px" }}> Soumettre </Button>{' '}</li>
                        </ModalBody>
                      </Modal>
                    </form>
                    </>
                    )
                    : (null)
              
                    
                    }
                    
                  </Popup>
                  
                </Marker>


              )
            })
            }
          </MarkerClusterGroup>


        </Map>

        





      </div>
    </>
  );


}


export default Mappy;